import { LOGO_LIGHT, LOGO_DARK } from "../lib/constants";

export function QairoLogo({ variant = "light", className = "" }) {
  const logoSrc = variant === "dark" ? LOGO_DARK : LOGO_LIGHT;

  return (
    <img
      src={logoSrc}
      alt="QAIRO AI"
      className={className}
      style={{
        height: "48px",
        width: "auto",
        objectFit: "contain"
      }}
    />
  );
}
